const sample = <T>(collection: Array<T>) =>
  collection[Math.floor(Math.random() * collection.length)]

export default sample
